/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "./src/styles/style.scss"

// Browser language detection and redirect
export const onClientEntry = () => {
    // Only run on first visit (check if user has already chosen a language)
    const hasVisited = localStorage.getItem('rahuc-language-chosen')
    
    if (hasVisited) return
    
    // Get browser language
    const browserLang = navigator.language || navigator.userLanguage
    const langCode = browserLang.split('-')[0].toLowerCase()
    
    // Supported languages
    const supportedLanguages = ['de', 'en', 'fr']
    
    // Check if current path already has a language prefix
    const currentPath = window.location.pathname
    const hasLangPrefix = supportedLanguages.some(lang => 
        currentPath.startsWith(`/${lang}/`) || currentPath === `/${lang}`
    )
    
    // If already on a language path or on German (default), don't redirect
    if (hasLangPrefix || langCode === 'de') {
        localStorage.setItem('rahuc-language-chosen', 'true')
        return
    }
    
    // If browser language is supported and different from default, redirect
    if (supportedLanguages.includes(langCode) && langCode !== 'de') {
        localStorage.setItem('rahuc-language-chosen', 'true')
        window.location.href = `/${langCode}${currentPath}`
    }
}
